/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestTrackingVersionStatsResponse
 */
export interface RequestTrackingVersionStatsResponse {
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingVersionStatsResponse
     */
    apiVersion?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingVersionStatsResponse
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingVersionStatsResponse
     */
    successCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingVersionStatsResponse
     */
    errorCount?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingVersionStatsResponse
     */
    successRate?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingVersionStatsResponse
     */
    errorRate?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingVersionStatsResponse
     */
    avgExecutionTime?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingVersionStatsResponse
     */
    maxExecutionTime?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingVersionStatsResponse
     */
    minExecutionTime?: number;
}

export function RequestTrackingVersionStatsResponseFromJSON(json: any): RequestTrackingVersionStatsResponse {
    return RequestTrackingVersionStatsResponseFromJSONTyped(json, false);
}

export function RequestTrackingVersionStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestTrackingVersionStatsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apiVersion': !exists(json, 'apiVersion') ? undefined : json['apiVersion'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'successCount': !exists(json, 'successCount') ? undefined : json['successCount'],
        'errorCount': !exists(json, 'errorCount') ? undefined : json['errorCount'],
        'successRate': !exists(json, 'successRate') ? undefined : json['successRate'],
        'errorRate': !exists(json, 'errorRate') ? undefined : json['errorRate'],
        'avgExecutionTime': !exists(json, 'avgExecutionTime') ? undefined : json['avgExecutionTime'],
        'maxExecutionTime': !exists(json, 'maxExecutionTime') ? undefined : json['maxExecutionTime'],
        'minExecutionTime': !exists(json, 'minExecutionTime') ? undefined : json['minExecutionTime'],
    };
}

export function RequestTrackingVersionStatsResponseToJSON(value?: RequestTrackingVersionStatsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'apiVersion': value.apiVersion,
        'count': value.count,
        'successCount': value.successCount,
        'errorCount': value.errorCount,
        'successRate': value.successRate,
        'errorRate': value.errorRate,
        'avgExecutionTime': value.avgExecutionTime,
        'maxExecutionTime': value.maxExecutionTime,
        'minExecutionTime': value.minExecutionTime,
    };
}

